import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { UploadResponse } from "../models/shared-component/upload-response";

@Injectable({
  providedIn: "root",
})

export class FileService {

  constructor(private http: HttpClient) { }

  upload(file: File): Observable<UploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<UploadResponse>(`${environment.api}/api/File`, formData);
  }

  // ยิงผ่าน HttpClient เพื่อให้ interceptor แนบ Bearer token ให้ (เดิมคืน URL ดิบไปเปิดด้วย
  // window.open ซึ่งไม่ผ่าน interceptor = ไม่มี token)
  download(generateFileName: string, fileExtension: string): Observable<Blob> {
    const fileNameBySystem = `${generateFileName}${fileExtension}`;
    return this.http.get(`${environment.api}/api/File`, {
      params: { fileNameBySystem },
      responseType: 'blob',
    });
  }
}
